/**
 * 📖 RÉPARTITION DES REVENUS SELON LE CORAN : source unique
 * Principes appliqués au partage des revenus entre l'investisseur et l'entrepreneur.
 * Utilisé par la page « Investir », la fiche projet, la fenêtre de paiement, la FAQ, les CGU,
 * l'accueil et la page « Financement ».
 * Traduction du sens des versets : Muhammad Hamidullah.
 */

export const SHARING_PRINCIPLES = [
  {
    key: 'riba',
    title: 'Aucun intérêt (ribâ)',
    text: "Votre argent n'est pas un prêt à intérêt. Aucun taux fixe, aucune somme garantie d'avance : vous recevez une part de ce que le projet gagne réellement.",
    verse: "Allah a rendu licite le commerce, et illicite l'intérêt.",
    reference: 'Sourate 2 (Al-Baqara), verset 275'
  },
  {
    key: 'partage',
    title: 'Gains et pertes partagés',
    text: "La part de chacun est une proportion fixée d'avance dans le contrat. Si le projet gagne moins, chacun reçoit moins. En cas de perte, l'investisseur la supporte dans la limite de son apport et l'entrepreneur perd le fruit de son travail.",
    verse: 'Vous ne léserez personne, et vous ne serez point lésés.',
    reference: 'Sourate 2 (Al-Baqara), verset 279'
  },
  {
    key: 'ecrit',
    title: 'Un contrat écrit, devant témoins',
    text: "Montant, durée, part de chacun et calendrier des reversements sont mis par écrit et signés par l'investisseur, l'entrepreneur et la plateforme.",
    verse: 'Quand vous contractez une dette à échéance déterminée, mettez-la en écrit.',
    reference: 'Sourate 2 (Al-Baqara), verset 282'
  },
  {
    key: 'consentement',
    title: 'Consentement et parole tenue',
    text: "Rien n'est caché : objectif, risques et clé de répartition sont connus avant de payer, et chacun respecte ce qu'il a signé.",
    verse: 'Ô les croyants ! Remplissez fidèlement vos engagements.',
    reference: "Sourate 5 (Al-Mâ'ida), verset 1"
  },
  {
    key: 'licite',
    title: 'Des activités licites',
    text: "Seuls les projets dont l'activité est licite et utile à la communauté sont publiés.",
    verse: 'De ce qui existe sur la terre, mangez le licite et le pur.',
    reference: 'Sourate 2 (Al-Baqara), verset 168'
  },
  {
    key: 'delai',
    title: 'Un délai, jamais de pénalité',
    text: "Un entrepreneur en difficulté obtient un délai : aucun intérêt de retard ne s'ajoute à ce qu'il doit.",
    verse: "À celui qui est dans la gêne, accordez un sursis jusqu'à ce qu'il soit dans l'aisance.",
    reference: 'Sourate 2 (Al-Baqara), verset 280'
  }
];

/** Résumé en une phrase (fiche projet, fenêtre de paiement, accueil) */
export const SHARING_SUMMARY =
  "La répartition des revenus suit les enseignements du Coran : aucun intérêt (ribâ), une part fixée d'avance en proportion des revenus réels du projet, gains et pertes partagés, contrat écrit.";

/** Précision sur le rendement visé affiché sur le site */
export const SHARING_RATE_NOTE =
  "Le rendement visé n'est pas un taux d'intérêt : c'est une estimation de votre part des revenus du projet. Ce que vous recevez dépend de ses résultats réels.";
